export let uiScale = 2;
/** Screen pixels; widgets use textPixels() in art pixels. */
export let fontSize = 14;
export const TEXT_SIZES = [0.85, 1, 1.15, 1.3];
let currentTextSize = 1;
export let scaleRevision = 0;
/** Physical pixels per CSS pixel; independent of the pixel-art UI scale. */
export let displayDensity = 1;
export function setDisplayDensity(density: number): void {
  const next = Number.isFinite(density) && density > 0 ? density : 1;
  if (next !== displayDensity) { displayDensity = next; scaleRevision++; }
}
/** Text-only supersampling: downsample smooth glyphs without changing sprite filtering or layout. */
export const TEXT_DENSITIES: readonly number[] = [1, 2, 4, 8];
export let textDensity = 4;
export function normalizeTextDensity(value: unknown): number {
  return TEXT_DENSITIES.some(density => density === value) ? value as number : 4;
}
export function setTextDensity(value: number): void {
  const next = normalizeTextDensity(value);
  if (next !== textDensity) { textDensity = next; scaleRevision++; }
}
export function textResolution(scale = 1): number { return scale * displayDensity * textDensity; }
export function autoUiScale(): number { return Math.max(1, Math.min(4, Math.floor(Math.min(innerWidth / 640, innerHeight / 360)))); }
export function setUiScale(setting: number, textSize = currentTextSize): void {
  currentTextSize = textSize;
  const next = setting > 0 ? Math.max(1, Math.min(setting, autoUiScale())) : autoUiScale();
  const fs = Math.round((8 + 3 * next) * (TEXT_SIZES[textSize] ?? 1));
  if (next !== uiScale || fs !== fontSize) scaleRevision++;
  uiScale = next; fontSize = fs;
}
export function textPixels(): number { return fontSize / uiScale; }
/** An icon in a line of text (coins, recipe and reward rows), in art pixels: a whole multiple of the 16 px sprite in
 *  screen pixels (crisp), about the text's height rather than the art's. */
export function rowIcon(): number { return 16 * Math.max(1, Math.floor(fontSize * 1.3 / 16)) / uiScale; }
